import { useResetPasswordMutation } from "@/modules/auth/services";
import { newPasswordValidationSchema } from "@/modules/auth/validations/validationSchema";
import { AppPaths } from "@/shared/common/enums";
import { useAppSelector, useNotify } from "@/shared/hooks";
import { Button } from "@ab.uitools/ui-library/components/Button";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { Text } from "@ab.uitools/ui-library/components/Text";
import type { TFormData } from "@ab.uitools/ui-library/types/globalTypes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { NewPasswordFormFields } from "./NewPasswordFormFields";

const initialValues = {
  password: "",
  confirmPassword: "",
};

export const NewPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showErrorAlertNotification } = useNotify();
  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const verificationId = useAppSelector((state) => state.auth.verificationId);

  const handleSubmit = (value: TFormData, isDirty: boolean) => {
    if (isDirty) {
      resetPassword({
        verificationId,
        newPassword: value.password,
      })
        .unwrap()
        .then(() => {
          navigate(AppPaths.Login);
        })
        .catch((err) => {
          showErrorAlertNotification(err);
        });
    }
  };

  return (
    <div className="full-width">
      <Text
        type="secondary"
        size="large"
        className="mt-24 enter-bew-password-text"
      >
        {t("auth.newPassword.enterNewPassword")}
      </Text>
      <div>
        <FormContainer
          className="full-width"
          onSubmit={(data, formState) => handleSubmit(data, formState.isDirty)}
          mode="onBlur"
          reValidateMode="onBlur"
          validationScheme={newPasswordValidationSchema({ t })}
          initialValues={initialValues}
          shouldFocusError
        >
          <NewPasswordFormFields/>
          <Button
            isLoading={isLoading}
            className="full-width mt-32"
            buttonActionType="submit"
            buttonText={t("general.confirm")}
            data-testid="reset-pasword-new-password-button"
            data-ga-id="reset-password-new-password-button"
            data-ga-action="Reset password, set new password"
          />
        </FormContainer>
      </div>
    </div>
  );
};
